import { FC } from 'react'
import { colors } from '@lmc/common/constants'

import { ButtonOLD, Due, theme, Todo } from '@lmc/ui-kit'

import { CardTitle } from './CardComponents'
import styled from 'styled-components'
import { Text } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import { useDashboardIncidents } from './hooks'
import { incidentReportsConstants } from 'locale/incidentReports'
import { useNavigate } from 'react-router-dom'

export const CaseIncidentsCard: FC = () => {
  const { t } = useTranslation(NAMESPACE.INCIDENT_REPORTS)

  const res = useDashboardIncidents()

  const navigate = useNavigate()

  const renderFooter = () => {
    return (
      <div className="lmc-home-card-footer">
        <div style={styles.footer}>
          <Text>
            <strong>{res?.totalCount} </strong>
            {t(incidentReportsConstants.DASHBOARD_INCIDENTS_30)}
          </Text>
          <ButtonOLD
            onClick={() =>
              navigate(`../reports/incidents/list`, {
                relative: 'path',
              })
            }
            type="secondary"
            style={{
              marginLeft: 'auto',
              marginRight: 0,
            }}
          >
            {t(incidentReportsConstants.DASHBOARD_VIEW_ALL)}
          </ButtonOLD>
        </div>
      </div>
    )
  }

  return (
    <div>
      <div className="lmc-home-card">
        <CardTitle title={t(incidentReportsConstants.DASHBOARD_CARD_TITLE)} />
        <div className="lmc-home-card-body-ss" style={{ height: 170 }}>
          <InfoWrapper>
            <div
              onClick={() =>
                navigate(
                  `../reports/incidents/list?statuses%5B0%5D=needsReview`,
                  {
                    relative: 'path',
                  }
                )
              }
            >
              <StyledText>
                <Todo />
                <CountWrapper>{res?.needsReview}</CountWrapper>
				<TranslationWrapper>
					&nbsp;
                	{t(incidentReportsConstants.DASHBOARD_NEEDS_REVIEW)}
				</TranslationWrapper>
              </StyledText>
            </div>
            <div
              onClick={() =>
                navigate(`../reports/incidents/list?statuses%5B0%5D=open`, {
                  relative: 'path',
                })
              }
            >
              <StyledText>
                <Due />
                <CountWrapper>{res?.open}</CountWrapper>
				<TranslationWrapper>
					&nbsp;
                	{t(incidentReportsConstants.DASHBOARD_OPEN)}
				</TranslationWrapper>
              </StyledText>
            </div>
            <div
              onClick={() =>
                navigate(
                  `../reports/incidents/actions?statuses%5B0%5D=notStarted&statuses%5B1%5D=pending`,
                  {
                    relative: 'path',
                  },
                )
              }
            >
              <StyledText>
                <Due color={theme.color.status.warning} />
                <CountWrapper>{res?.openActions}</CountWrapper>
				<TranslationWrapper>
					&nbsp;
					{t(incidentReportsConstants.DASHBOARD_UNRESOLVED)}
				</TranslationWrapper>
              </StyledText>
            </div>
          </InfoWrapper>
        </div>
        {renderFooter()}
      </div>
    </div>
  )
}

const styles = {
  dot: {
    left: -20,
    top: -18,
    width: 42,
    height: 42,
    border: '3px solid rgba(0,0,0,0)',
    borderRadius: 24,
    backgroundColor: colors.grey,
    alignItems: 'center',
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 50,
  },
  iconStyle: {
    backgroundSize: '14px !important',
    backgroundPosition: 'center center !important',
  },
  title: {
    opacity: 0.8,
  },
  conflicts: {
    color: colors.red,
    textDecoration: 'underline',
    marginTop: 5,
    display: 'flex',
    alignItems: 'center',
  },
}

const InfoWrapper = styled.div`
  padding-top: 10px;
`

const CountWrapper = styled.strong`
  margin-left: 5px;
`

const StyledText = styled(Text)`
  display: flex;
  align-items: center;
  margin-top: 5px;
  color: ${(props) => props.theme.color.neutral.color4};
  cursor: pointer;

  &:hover {
	text-decoration: underline;
  }
`

const TranslationWrapper = styled.div`
	padding-top: 1px;
`
